import { useTheme } from '../../hooks/useTheme';

import { NAV_THEMES } from './nav-tokens';
import type { NavCollapseState } from './navCollapse';
import NavPanelToggle from './NavPanelToggle';
import { COLLAPSED_ONLY, FOOTER_ALIGN, type PanelVariant } from './navRowClass';
import SignOutItem from './SignOutItem';

interface NavPanelFooterProps {
  variant: PanelVariant;
  onSetCollapse: (next: NavCollapseState) => void;
}

/** The panel's pinned footer: the icon band's expand control, and sign out for
 *  both bands. The labelled band's collapse control lives in its header
 *  instead, so each band has exactly one toggle and its position says which
 *  direction it goes. */
export default function NavPanelFooter({ variant, onSetCollapse }: NavPanelFooterProps) {
  const { theme } = useTheme();
  const t = NAV_THEMES[theme];

  return (
    <div
      className={`flex shrink-0 flex-col gap-1 pt-2 ${FOOTER_ALIGN[variant]}`}
      style={{ borderTop: `1px solid ${t.border}` }}
    >
      <div className={`flex-col items-center gap-1 ${COLLAPSED_ONLY[variant]}`}>
        <NavPanelToggle expanded={false} onSet={onSetCollapse} className="flex" placement="rail" />
      </div>
      <SignOutItem variant={variant} />
    </div>
  );
}
